'use strict';

import administrar from './Administrar/administrarCuentaCtrl';
import facturacion from './Facturacion/facturacionCtrl';
import administrar_metodo_pago from './Administrar/Metodo de Pago/metodoPagoCtrl';
import administrar_baja from './Administrar/BajaCuenta/bajaCuentaCtrl';

export default angular.module('contartemx.cuenta', [
    'contartemx.cuenta.administrar',
    'contartemx.cuenta.facturacion',
    'contartemx.cuenta.administrar.metodo_pago',
    'contartemx.cuenta.administrar.baja'

]).config(($stateProvider) => {

    $stateProvider.state('cuenta', {
        url: '/Cuenta',
        abstract: true,
        views:
        {
            '': {
                template: require('../../../../app/views/MainContainer.html'),
                controller: 'CuentaCtrl'
            }
        },
        resolve: {
            authorize: ['authorization', authorization => authorization.authorize()]
        },
        data: { roles: ['Administracion'] }
    })
        .state('cuenta.administrar', {
            url: '/Administrar',
            views:
            {
                'main': {
                    template: require('../../../../app/views/Cuenta/Administrar_Cuenta.html'),
                    controller: 'AdministrarCuentaCtrl'
                }
            },
            data: { roles: ['Administracion_Cuentas'] },
            redirectTo: 'administracion.cuentas'
        })
        .state('cuenta.administrar.metodo_pago', {
            url: '/MetodoDePago',
            views:
            {
                'main@cuenta': {
                    template: require('../../../../app/views/Cuenta/MetodoDePago.html'),
                    controller: 'MetodoDePagoCtrl'
                }
            },
            data: { roles: ['Administracion_Cuentas'] }
        })
        .state('cuenta.administrar.baja', {
            url: '/Baja',
            views:
            {
                'main@cuenta': {
                    template: require('../../../../app/views/Cuenta/Baja_Cuenta.html'),
                    controller: 'BajaCuentaCtrl'
                }
            },
            data: { roles: ['Administracion_Cuentas'] },
            redirectTo: 'administracion.cuentas'
        })
        .state('cuenta.facturacion', {
            url: '/Facturacion',
            views:
            {
                'main': {
                    template: require('../../../../app/views/Cuenta/Historial_Facturacion.html'),
                    controller: 'FacturacionCtrl'
                }
            },
            data: { roles: ['Administracion_Cuentas'] },
            redirectTo: 'administracion.cuentas'
        });
})

    .controller('CuentaCtrl', ($scope, $state) => {

    })

    .controller('NuevaCuentaCtrl', ($scope, callToWebService, $uibModalInstance, ctsMayores, nombrecuenta, cuentamayorselect, categoriaselect, cuentamenorselect, listCategories, cuentaOriginal) => {
        $scope.CuentaNombre = nombrecuenta;
        $scope.CuentasMayores = ctsMayores;
        $scope.Categories = listCategories;
        $scope.valores = {
            CuentasAgregadas: []
        };
        $scope.disableSaveButton = $scope.valores.CuentasAgregadas.length < 1;

        if (cuentamayorselect) {
            $scope.valores.optCuentaMayor = cuentamayorselect;
        }

        if (cuentamayorselect.ClaveCuentaMayor == 11) {
            $scope.valores.optCategoria = categoriaselect;
            $scope.muestraCategorias = true;
            $scope.muestraSubCategories = true;
        } else {
            $scope.muestraSubCategories = true;
        }

        if (cuentamenorselect)
            $scope.valores.optCuentaMenor = cuentamenorselect;

        $scope.GetSubCategories = function () {
            for (var x = 0; x < $scope.Categories.length; x++) {
                if ($scope.Categories[x].Numero == $scope.valores.optCategoria.Numero) {
                    $scope.valores.optCuentaMayor.CuentasMenores = $scope.Categories[x].SubCategorias;
                    $scope.muestraSubCategories = true;
                    break;
                }
            }
        };

        $scope.addItems = function (f) {
            var cuentaMenorData = f.cuentaMenor.$viewValue;
            $scope.valores.CuentasAgregadas.push({
                Nombre: f.cuentaNombre.$viewValue,
                NombreMenor: cuentaMenorData.Nombre,
                NombreMayor: f.cuentaMayor.$viewValue.Nombre,
                Numero: cuentaMenorData.Numero,
                ClaveTipo: cuentaMenorData.ClaveTipo
            });
            $("#cuentaNombre").val('');
            f.cuentaNombre.$setValidity('required', false);
            $scope.disableSaveButton = $scope.valores.CuentasAgregadas.length < 1;
        };

        $scope.deleteItems = function (i) {
            $scope.valores.CuentasAgregadas.splice(i, 1);
            $scope.disableSaveButton = $scope.valores.CuentasAgregadas.length < 1;
        };

        $scope.updateCuenta = function (f) {
            f.cuentaMenor.$setValidity('required', false);
            $scope.NoSePuedeCrear = false;
            if ($scope.valores.optCuentaMayor.ClaveCuentaMayor == 11) {
                $scope.muestraCategorias = true;
                $scope.muestraSubCategories = false;
                $scope.valores.optCategoria = { Numero: 0 };
            } else {
                $scope.muestraCategorias = false;
                $scope.muestraSubCategories = true;
            }
        };

        $scope.update = function (f) {
            $scope.NoSePuedeCrear = f.cuentaMenor.$viewValue.NoSePuedeCrear;
        };

        $scope.saveChanges = function () {
            $scope.disableSaveButton = true;
            callToWebService.postCall('AgregarCuentas', { cuentas: $scope.valores.CuentasAgregadas },
                function sucess(data) {
                    if (!data.EsError) {
                        $uibModalInstance.close(data);
                    }
                    else {
                        $scope.alert = [];
                        $scope.alert.push({ type: 'error', msg: data.Mensaje });
                    }
                },
                function error(data) {
                    $scope.alert = [];
                    $scope.alert.push({ type: 'error', msg: data.Mensaje });
                }
            );
        };

        $scope.closeModalAlert = function (i) {
            $scope.alert.splice(i, 1);
        };

        $scope.closeModal = function () {
            $uibModalInstance.dismiss();
        };
    });
